import { render, staticRenderFns } from "./DataTablePagination.vue?vue&type=template&id=1a4bd4d3&scoped=true"
import script from "./DataTablePagination.vue?vue&type=script&lang=js"
export * from "./DataTablePagination.vue?vue&type=script&lang=js"
import style0 from "./DataTablePagination.vue?vue&type=style&index=0&id=1a4bd4d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4bd4d3",
  null
  
)

export default component.exports